import { Component } from "react";

import DataTable from "components/DigiHapi/DataTable";
import {
	DragTrComponent,
	makeDropTbodyComponent
} from "components/DigiHapi/DraggableTable";
import { DragDropContext } from "react-beautiful-dnd";

// @mui material components
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import Notification from "components/DigiHapi/Notification";

import { VscDebugStepInto } from "react-icons/vsc";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { fetchGetEquipments } from "actions/equipment";
import {
	fetchGetCommunityDetails,
	fetchGetCurrentCommunityDetails,
	fetchReorderCommunityEquipments
} from "actions/community";

import { COMMUNITY_EQUIPMENTS_ON_DRAG_END } from "actions/types";
import { getUnusedEquipments } from "selectors/community";

const DropTbodyComponentUsed = makeDropTbodyComponent("used");
const DropTbodyComponentUnused = makeDropTbodyComponent("unused");

class CommunityPlacesPage extends Component {
	state = {
		br: false,
		color: "info",
		message: null
	};

	componentDidMount() {
		const { fetchGetEquipments, community } = this.props;
		fetchGetEquipments(community._id);
	}

	componentDidUpdate(prevProps, prevState) {
		const { fetchGetCommunityDetails, snackErrorMsg, snackInfoMsg, community } =
			this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			fetchGetCommunityDetails(community._id);
			this.autoCloseMessage();
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	getCommunityEquipments = () => {
		const { communityEquipments } = this.props;

		const equipmentsObj = communityEquipments.map(({ _id, name }) => {
			return {
				_id,
				name
			};
		});
		return equipmentsObj;
	};

	getUnusedEquipments = () => {
		const { unusedEquipments } = this.props;

		const equipmentsObj = unusedEquipments.map(({ _id, name }) => {
			return {
				_id,
				name
			};
		});
		return equipmentsObj;
	};

	handleDragEnd = result => {
		const { dispatch, equipments } = this.props;
		dispatch({
			type: COMMUNITY_EQUIPMENTS_ON_DRAG_END,
			result,
			name: equipments[result.draggableId].name
		});
	};

	render() {
		const { color, message } = this.state;
		const {
			isFetching,
			community,
			equipmentsIds,
			areEquipmentsReordered,
			fetchReorderCommunityEquipments,
			fetchGetCurrentCommunityDetails,
			totalEquipments
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							<VscDebugStepInto size={24} />
							<MDTypography variant="h6" color="white" ml={1.5}>
								{"Lieux de rendez-vous"}
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							<DragDropContext onDragEnd={this.handleDragEnd}>
								{totalEquipments > 0 && (
									<Grid container spacing={3}>
										<Grid item xs={12} sm={6}>
											<DataTable
												TrComponent={DragTrComponent}
												TbodyComponent={DropTbodyComponentUsed}
												data={this.getCommunityEquipments()}
												columns={[
													{
														Header: "Lieux de rendez-vous",
														accessor: "name",
														sortable: false,
														filterable: false
													},
													{
														Header: "",
														accessor: "empty",
														sortable: false,
														filterable: false
													}
												]}
												// loading={isFetchingList}
												defaultPageSize={totalEquipments}
												showPaginationTop={false}
												showPaginationBottom={false}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<DataTable
												TrComponent={DragTrComponent}
												TbodyComponent={DropTbodyComponentUnused}
												data={this.getUnusedEquipments()}
												columns={[
													{
														Header: "Piochez ou retirez des éléments ici",
														accessor: "name",
														sortable: false,
														filterable: false
													},
													{
														Header: "",
														accessor: "empty",
														sortable: false,
														filterable: false
													}
												]}
												// loading={isFetchingList}
												defaultPageSize={totalEquipments}
												showPaginationTop={false}
												showPaginationBottom={false}
											/>
										</Grid>
									</Grid>
								)}
							</DragDropContext>
						</MDBox>
						<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
							<MDButton
								variant="outlined"
								color="secondary"
								disabled={!areEquipmentsReordered || isFetching}
								onClick={fetchGetCurrentCommunityDetails}
							>
								{"Restaurer"}
							</MDButton>
							<MDButton
								variant="gradient"
								color="primary"
								disabled={!areEquipmentsReordered || isFetching}
								onClick={() =>
									fetchReorderCommunityEquipments(community._id, equipmentsIds)
								}
							>
								{isFetching ? (
									<CircularProgress size={16} color="inherit" />
								) : (
									"Réorganiser"
								)}
							</MDButton>
						</MDBox>
					</Card>
				</Grid>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetching,
		snackInfoMsg,
		snackErrorMsg,
		equipments: communityEquipments,
		areEquipmentsReordered
	} = state.communityReducer;

	const { equipments } = state.equipmentReducer;

	const { community } = state.entitiesReducer;

	return {
		isFetching,
		totalEquipments: Object.values(equipments).length,
		equipments,
		communityEquipments:
			communityEquipments && Object.values(communityEquipments),
		equipmentsIds: communityEquipments && Object.keys(communityEquipments),
		unusedEquipments: Object.values(getUnusedEquipments(state)),
		snackInfoMsg,
		snackErrorMsg,
		areEquipmentsReordered,
		community
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetEquipments,
			fetchGetCommunityDetails,
			fetchGetCurrentCommunityDetails,
			fetchReorderCommunityEquipments
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CommunityPlacesPage);
